/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {ILogService} from 'angular';
import IRootScopeService = angular.IRootScopeService;

/**
 * Dieser Service soll helfen die Events die vom angular-ui-route Service geworfen werden zu debuggen
 */
export class NavigationLogger {

    active: boolean = false;

    static $inject = ['$rootScope', '$log'];

    /* @ngInject */
    constructor($rootScope: IRootScopeService, private $log: ILogService) {

        $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
            if (this.active) {
                $log.debug('$stateChangeStart --- event, toState, toParams, fromState, fromParams');
                $log.debug(event, toState, toParams, fromState, fromParams);
            }
        });
        $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
            if (this.active) {
                $log.debug('$stateChangeError --- event, toState, toParams, fromState, fromParams, error');
                $log.debug(event, toState, toParams, fromState, fromParams, error);
            }
        });
        $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
            if (this.active) {
                $log.debug('$stateChangeSuccess --- event, toState, toParams, fromState, fromParams');
                $log.debug(event, toState, toParams, fromState, fromParams);
            }
        });
        $rootScope.$on('$viewContentLoading', (event, viewConfig) => {
            if (this.active) {
                $log.debug('$viewContentLoading --- event, viewConfig');
                $log.debug(event, viewConfig);
            }
        });
        $rootScope.$on('$viewContentLoaded', (event) => {
            if (this.active) {
                $log.debug('$viewContentLoaded --- event');
                $log.debug(event);
            }
        });
        $rootScope.$on('$stateNotFound', (event, unfoundState, fromState, fromParams) => {
            if (this.active) {
                $log.debug('$stateNotFound --- event, unfoundState, fromState, fromParams');
                $log.debug(event, unfoundState, fromState, fromParams);
            }
        });

    }

    public toggle() {
        this.active = !this.active;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/NavigationLogger.ts